
import { GridPostList, Loader } from "@/components/shared";
import { useGetCurrentUser } from "@/lib/react-query/queries";
import { databases, appwriteConfig } from "@/lib/appwrite/config";
import { Query } from "appwrite";
import { useQuery } from "@tanstack/react-query";

const Saved = () => {
  const { data: currentUser } = useGetCurrentUser();

  // ✅ NEW: Query posts saved by current user
  const { data: savedPosts, isLoading } = useQuery({
    queryKey: ["savedPosts", currentUser?.$id],
    queryFn: async () => {
      if (!currentUser) return [];
      
      const posts = await databases.listDocuments(
        appwriteConfig.databaseId,
        appwriteConfig.postCollectionId,
        [
          Query.contains("savedBy", currentUser.$id),
          Query.orderDesc("$createdAt"),
          Query.limit(50)
        ]
      );
      
      return posts.documents;
    },
    enabled: !!currentUser,
  });

  return (
    <div className="saved-container">
      <div className="flex gap-2 w-full max-w-5xl">
        <img
          src="/assets/icons/save.svg"
          width={36}
          height={36}
          alt="edit"
          className="invert-white"
        />
        <h2 className="h3-bold md:h2-bold text-left w-full">Saved Posts</h2>
      </div>

      {!currentUser || isLoading ? (
        <Loader />
      ) : (
        <ul className="w-full flex justify-center max-w-5xl gap-9">
          {!savedPosts || savedPosts.length === 0 ? (
            <p className="text-light-4">No available posts</p>
          ) : (
            <GridPostList posts={savedPosts} showStats={false} />
          )}
        </ul>
      )}
    </div>
  );
};

export default Saved;
